import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW6901ProposalTabModel } from "../kymw6901-proposal-tab.model";

/**
 * 商品マスタ登録サービス
 *
 * @export RegistNewGoodsProposalGoodsService
 * @class RegistNewGoodsProposalGoodsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistNewGoodsProposalGoodsService extends PlessJsonResponderSub<any> {
  private model: KYMW6901ProposalTabModel;
  private proposalId: string;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistNewGoodsProposalGoodsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ProposalId: this.proposalId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistNewGoodsProposalGoodsService
   */
  execute(
    model: KYMW6901ProposalTabModel,
    proposalId: string,
    successFunc?: () => void
  ) {
    this.model = model;
    this.proposalId = proposalId;
    this.successFunc = successFunc;
    this.send('registNewGoodsProposalGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * 
   * @memberof RegistNewGoodsProposalGoodsService
   */
  success(data: any): void {
    if (this.successFunc) {
      this.successFunc();
    }
  }
}

